<template>
  <section class="assessmentSection questionsSection">
    <div class="questionsTopBG"></div>

    <div class="pageContent">
      <div class="pageTitle">Let's get familiar with your security concerns.</div>

      <question id="5" lead-key="homeAwayConcern" ref="homeAwayConcern">
        <div
          slot="learn-more"
        >Most advertised systems offer basic Intrusion protection when you are away and do not take into considerations other points of entry. Motion sensors are commonly used to detect window entry when your away but offer no protection when you at home should someone enter through unprotected windows such as basement windows.</div>
      </question>

      <!-- ADVICE -->
      <transition name="fade">
        <div v-if="homeAndEssential">
          <inline-advice>
            <div slot="title">Total peace of mind when you’re home</div>
            <div slot="text">
              <p>When you’re at home, motion sensors are inactive. That means ground level windows are vulnerable to intrusion.</p>
              <p>
                If that concerns you, we suggest switching to
                <router-link to="/assessment/protection-level">Total Protection</router-link>.
              </p>
            </div>
          </inline-advice>
        </div>
      </transition>

      <!-- QUESTION -->
      <transition name="fade">
        <div v-if="lead.homeAwayConcern">
          <question id="6" lead-key="peopleThingsConcern" ref="peopleThingsConcern">
            <div
              slot="learn-more"
            >According to the FBI 40% of violent crimes that take place in the home start as a would-be break in attempt. Those at greater at risk could be women children and elderly is left home alone.</div>
          </question>
        </div>
      </transition>

      <!-- ADVICE -->
      <transition name="fade">
        <inline-advice v-if="peopleAndEssential">
          <div slot="title">Avoid confronting intruders</div>
          <div slot="text">
            Should a would be burglar perceive no one is at home. A ground level window may become an easier point of entry. This could result in confrontation between an intruder and a family member. If this concerns you, we suggest switching to
            <router-link to="/assessment/protection-level">Total Protection</router-link>.
          </div>
        </inline-advice>
      </transition>

      <continue-button :before="mixpanelTracking" to="/assessment/pets" />
      <div class="startOverSection text-center">
        <a
          href="/assessment/start-over"
          onclick="mixpanel.track('startedOver')"
        >Clear data and start over</a>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["lead"]),

    homeAndEssential() {
      let essential = this.lead.protectionLevel == "Essential";
      let home = this.lead.homeAwayConcern == "Home";
      return essential && home;
    },

    peopleAndEssential() {
      let essential = this.lead.protectionLevel == "Essential";
      let people = this.lead.peopleThingsConcern == "People";
      return essential && people;
    }
  },

  methods: {
    mixpanelTracking() {
      let data = {
        A_Concern_HomeAway: this.lead.homeAwayConcern,
        A_Concern_PeopleThing: this.lead.peopleThingsConcern
      };
      mixpanel.track("completedConcernsSection", data);
      mixpanel.people.set(data);
    }
  },

  mounted() {
    this.$Progress.set(42);
  }
};
</script>

<style lang="css">
</style>
